import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c22960"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-container" }
const _hoisted_2 = { style: {"padding":"8px"} }
const _hoisted_3 = {
  key: 0,
  class: "pagination"
}
const _hoisted_4 = {
  key: 1,
  class: "pagination"
}
const _hoisted_5 = { class: "info-title" }
const _hoisted_6 = { class: "info-title" }
const _hoisted_7 = { class: "info-title" }
const _hoisted_8 = { class: "info-title" }
const _hoisted_9 = { class: "info-title" }
const _hoisted_10 = { class: "info-title" }
const _hoisted_11 = { class: "info-title" }
const _hoisted_12 = { class: "info-title" }
const _hoisted_13 = { class: "label-form" }
const _hoisted_14 = { class: "label-form" }
const _hoisted_15 = { class: "label-form" }
const _hoisted_16 = { class: "label-form" }
const _hoisted_17 = { class: "label-form" }
const _hoisted_18 = { class: "label-form" }
const _hoisted_19 = { class: "label-form" }
const _hoisted_20 = { class: "label-form" }
const _hoisted_21 = { class: "label-form" }
const _hoisted_22 = { class: "label-form" }
const _hoisted_23 = { class: "label-form" }
const _hoisted_24 = { class: "label-form" }
const _hoisted_25 = { class: "label-form" }
const _hoisted_26 = { class: "label-form" }
const _hoisted_27 = { class: "btns-container" }
const _hoisted_28 = { class: "label-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LbrxLoaderSpinner = _resolveComponent("LbrxLoaderSpinner")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_check_circle_two_tone = _resolveComponent("check-circle-two-tone")!
  const _component_close_circle_two_tone = _resolveComponent("close-circle-two-tone")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_LbrxLoaderSpinner, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_breadcrumb, { style: {"margin":"16px 0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/'))),
            class: "breadcrumb-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Pos.Home')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Pos.Workers')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_button, {
        class: "add-btn",
        onClick: _ctx.showAddDrawer
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('Pos.Add')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.state.data,
        pagination: false,
        class: "table-container"
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.key=='actions')
            ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('Pos.View')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "view-btn",
                        onClick: () => _ctx.showDisplayDrawer(record)
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_EyeOutlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('Pos.Edit')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: () => _ctx.showDrawer(record)
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_EditOutlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('Pos.Delete')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: "",
                        onClick: ($event: any) => (_ctx.showDeletePopup(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_DeleteOutlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key === 'created_at')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDisplayDate(record[column.key])), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key==='is_active')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (record.is_active===1 || record.is_active===true)
                  ? (_openBlock(), _createBlock(_component_check_circle_two_tone, {
                      key: 0,
                      "two-tone-color": "#52c41a"
                    }))
                  : _createCommentVNode("", true),
                (record.is_active===0 || record.is_active===false)
                  ? (_openBlock(), _createBlock(_component_close_circle_two_tone, {
                      key: 1,
                      "two-tone-color": "#ff4d4f"
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        customFilterDropdown: _withCtx(({ setSelectedKeys, selectedKeys, confirm, clearFilters, column }) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_input, {
              ref: "searchInput",
              placeholder: `${column.title}`,
              value: selectedKeys[0],
              style: {"width":"188px","margin-bottom":"8px","display":"block"},
              onChange: e => setSelectedKeys(e.target.value ? [e.target.value] : []),
              onPressEnter: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, null, 8, ["placeholder", "value", "onChange", "onPressEnter"]),
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              style: {"width":"90px","margin-right":"8px"},
              onClick: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Pos.Search')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              size: "small",
              style: {"width":"90px"},
              onClick: ($event: any) => (_ctx.handleReset(clearFilters))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Pos.Reset')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        customFilterIcon: _withCtx(({ filtered }) => [
          _createVNode(_component_search_outlined, {
            style: _normalizeStyle({ color: filtered ? '#108ee9' : undefined })
          }, null, 8, ["style"])
        ]),
        _: 1
      }, 8, ["columns", "data-source"]),
      (_ctx.state.totalPagesSearch ===0 && !_ctx.state.beginSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_a_pagination, {
              class: "paginationArrows",
              current: _ctx.currentPage,
              "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
              total: _ctx.state.totalPages,
              onChange: _ctx.handlePageChange,
              "default-page-size": _ctx.perPage
            }, null, 8, ["current", "total", "onChange", "default-page-size"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.totalPagesSearch !==0 && _ctx.state.beginSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_pagination, {
              class: "paginationArrows",
              "model:current": "currentPageSearch",
              total: _ctx.state.totalPagesSearch,
              onChange: _ctx.handlePageChangeSearch,
              "default-page-size": _ctx.perPageSearch
            }, null, 8, ["total", "onChange", "default-page-size"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_drawer, {
        open: _ctx.openDisplay,
        "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openDisplay) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        title: _ctx.t('Pos.WorkerInfo'),
        placement: "right",
        width: _ctx.modalWidth,
        onAfterOpenChange: _ctx.afterOpenChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "formRef",
            model: _ctx.form,
            rules: _ctx.rules,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('Pos.Username')) + " :", 1),
                        _createTextVNode(_toDisplayString(_ctx.form.username), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('Pos.FisrtName')) + " :", 1),
                        _createTextVNode(_toDisplayString(_ctx.form.first_name), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('Pos.LastName')) + " :", 1),
                        _createTextVNode(_toDisplayString(_ctx.form.last_name), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('Pos.Email')) + " :", 1),
                        _createTextVNode(_toDisplayString(_ctx.form.email), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Pos.Badge')) + " :", 1),
                        _createTextVNode(_toDisplayString(_ctx.form.badge_id), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('Pos.Active')), 1),
                        (_ctx.form.is_active===1 || _ctx.form.is_active===true)
                          ? (_openBlock(), _createBlock(_component_check_circle_two_tone, {
                              key: 0,
                              "two-tone-color": "#52c41a"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.form.is_active===0 || _ctx.form.is_active===false)
                          ? (_openBlock(), _createBlock(_component_close_circle_two_tone, {
                              key: 1,
                              "two-tone-color": "#ff4d4f"
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('Pos.Pin')) + " :", 1),
                        _createTextVNode(_toDisplayString(_ctx.form.pin), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('Pos.CreatedAt')) + " :", 1),
                        _createTextVNode(_toDisplayString(_ctx.formatStringDate(_ctx.form.created_at)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["open", "title", "width", "onAfterOpenChange"]),
      _createVNode(_component_a_drawer, {
        open: _ctx.open,
        "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.open) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        title: _ctx.t('Pos.UpdateWorker'),
        placement: "right",
        width: _ctx.modalWidth,
        onAfterOpenChange: _ctx.afterOpenChange
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateUser(_ctx.form.id)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('Pos.Update')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                danger: "",
                onClick: _ctx.cancelUpdate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('Pos.Cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "formRef",
            model: _ctx.form,
            rules: _ctx.rules,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "username" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('Pos.Username')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.form.username,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.username) = $event)),
                            placeholder: _ctx.t('Pos.Username'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: "first_name"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('Pos.FisrtName')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.form.first_name,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.first_name) = $event)),
                            placeholder: _ctx.t('Pos.FisrtName'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: "last_name"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('Pos.LastName')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.form.last_name,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.last_name) = $event)),
                            placeholder: _ctx.t('Pos.LastName'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "email" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('Pos.Email')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.form.email,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event)),
                            placeholder: _ctx.t('Pos.Email'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "pin" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('Pos.Pin')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.form.pin,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.pin) = $event)),
                            placeholder: _ctx.t('Pos.Pin'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "created_at" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('Pos.CreatedAt')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            "show-time": "",
                            placeholder: _ctx.t('Pos.CreatedAt'),
                            class: "date-picker",
                            value: _ctx.formatDate(_ctx.form.created_at),
                            disabled: ""
                          }, null, 8, ["placeholder", "value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "is_active" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t('Pos.Active')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_switch, {
                            checked: _ctx.form.is_active,
                            "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.is_active) = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["open", "title", "width", "onAfterOpenChange"]),
      _createVNode(_component_a_drawer, {
        open: _ctx.openAdd,
        "onUpdate:open": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.openAdd) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        title: _ctx.t('Pos.AddWorker'),
        placement: "right",
        width: _ctx.modalWidth,
        onClose: _ctx.resetFormAdd
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.add
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('Pos.Add')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                danger: "",
                onClick: _ctx.resetFormAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('Pos.Cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "addFormRef",
            model: _ctx.addForm,
            rules: _ctx.rules,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: "username"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t('Pos.Username')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.addForm.username,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.addForm.username) = $event)),
                            placeholder:  _ctx.t('Pos.Username'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: "first_name"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.t('Pos.FisrtName')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.addForm.first_name,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.addForm.first_name) = $event)),
                            placeholder: _ctx.t('Pos.FisrtName'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: "last_name"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('Pos.LastName')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.addForm.last_name,
                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addForm.last_name) = $event)),
                            placeholder: _ctx.t('Pos.LastName'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        name: "email",
                        "has-feedback": "",
                        "validate-status": _ctx.validatingStatus,
                        help: _ctx.validatingHelp
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t('Pos.Email')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.addForm.email,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addForm.email) = $event)),
                            placeholder: _ctx.t('Pos.Email'),
                            onBlur: _ctx.validateEmail
                          }, null, 8, ["value", "placeholder", "onBlur"])
                        ]),
                        _: 1
                      }, 8, ["validate-status", "help"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "store_id" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.t('Pos.Store')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.addForm.store_id,
                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addForm.store_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.stores, (store) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: store.id,
                                  value: store.id,
                                  selected: store.id === _ctx.form.store_id 
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(store.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: "pass"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.t('Pos.Password')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_password, {
                            value: _ctx.addForm.pass,
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addForm.pass) = $event)),
                            placeholder: _ctx.t('Pos.Password'),
                            type: "password",
                            autocomplete: "off"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: "checkPass"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.t('Pos.Confirmpassword')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_password, {
                            value: _ctx.addForm.checkPass,
                            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.addForm.checkPass) = $event)),
                            placeholder: _ctx.t('Pos.Confirmpassword'),
                            type: "password",
                            autocomplete: "off"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["open", "title", "width", "onClose"]),
      _createVNode(_component_a_modal, {
        open: _ctx.openDiscountModal,
        "onUpdate:open": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.openDiscountModal) = $event))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_a_button, {
              key: "back",
              onClick: _ctx.cancelModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Pos.Cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        title: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.t('Pos.ManageDiscounts')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "discountFormRef",
            model: _ctx.discountForm,
            rules: _ctx.discountRules,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "value" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.t('Pos.DiscountValue')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.discountForm.value,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.discountForm.value) = $event)),
                            placeholder: _ctx.t('Pos.DiscountValue'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["open"])
    ])
  ], 64))
}